import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import useWizardContext from '@swf/core/hooks/useWizardContext';
import { select } from '@swf/core/store';

import type { CardType } from '../../types/cardType';
import { getSavedMethod } from '../../utils/cashier';

import { container } from './SavePaymentInfo.scss';
import FirstTimeDepositCheckboxes from './components/FirstTimeDepositCheckboxes/FirstTimeDepositCheckboxes';
import ReloaderCheckboxes from './components/ReloaderCheckboxes/ReloaderCheckboxes';
import SavedCardCheckboxes from './components/SavedCardCheckboxes/SavedCardCheckboxes';

export interface Props {
  type: CardType;
}

export const saveCardField = 'deposit.saveCardInfo';
export const fastDepositField = 'deposit.makeFastDeposit';

const SavePaymentInfo: React.FC<Props> = ({ type }) => {
  const isReloader = useSelector(select.account.isReloader);

  const {
    data: { savedCards, savedCardInfoId }
  } = useWizardContext();
  const [isPrefered, setIsPreferred] = useState(false);

  useEffect(() => {
    if (savedCards?.length && savedCardInfoId) {
      const [savedCardInfo] = getSavedMethod(savedCards, savedCardInfoId);
      if (savedCardInfo?.savedCard?.fastDeposit) {
        setIsPreferred(true);
      }
    }
  }, [savedCardInfoId, savedCards]);

  return (
    (!isReloader && (
      <div className={container}>
        <FirstTimeDepositCheckboxes type={type} />
      </div>
    )) ||
    (!savedCardInfoId && (
      <div className={container}>
        <ReloaderCheckboxes type={type} />
      </div>
    )) ||
    (!isPrefered && (
      <div className={container}>
        <SavedCardCheckboxes />
      </div>
    )) ||
    null
  );
};

export default SavePaymentInfo;
